import { useEffect, useState } from "react";
import { trpc } from "../../main/components/trpc.ts";
import convertTextForDisplay from "../filtersTransforms/convertTextForDisplay";
import {
  remainingChars,
  remainingSenderChars,
} from "../filtersTransforms/countChars";
import { z } from "zod/v4";
import { useForm, useStore } from "@tanstack/react-form";
import useOwner from "../../users/hooks/useOwner";
import HInputGroup from "../../main/components/HInputGroup";
import Button from "../../main/components/Button";
import classNames from "classnames";

const RemindersParams = () => {
  const { data: prefs } = trpc.preference.get.useQuery();
  const previewDoctorName = "Dr Dupont";

  const owner = useOwner();

  const [isEditingEmailTxt, setIsEditingEmailTxt] = useState(false);
  const [isEditingSmsTxt, setIsEditingSmsTxt] = useState(false);
  const [isEditingSmsName, setIsEditingSmsName] = useState(false);
  const [isEditingEmailExpediteur, setIsEditingEmailExpediteur] =
    useState(false);
  const [isEditingConfirmText, setIsEditingConfirmText] = useState(false);

  const [isEditingPrefs, setIsEditingPrefs] = useState(false);

  const editPreferencesSaveMutation =
    trpc.preference.saveEditedPrefs.useMutation({
      onSettled: () => {
        trpcUtils.preference.invalidate();
      },
      onSuccess: () => {
        trpcUtils.preference.invalidate();
        prefsForm.reset();
      },
    });

  const prefsForm = useForm({
    defaultValues: {
      id: prefs?.id || "",
      owner_id: prefs?.owner_id || owner || "",
      duree_min_rdv: prefs?.duree_min_rdv.toString() || "15",
      duree_default_rdv: prefs?.duree_default_rdv.toString() || "30",
      time_division: prefs?.time_division.toString() || "15",
      email_expediteur: prefs?.email_expediteur || "",
      email_subject: prefs?.email_subject || "",
      email_text: prefs?.email_text || "",
      ebd_subject: prefs?.ebd_subject || "",
      sms_name: prefs?.sms_name || "",
      sms_text: prefs?.sms_text || "",
      blocs_ratio: prefs?.blocs_ratio?.toString() || "",
      blocs_unlocked_days: prefs?.blocs_unlocked_days?.toString() || "",
      confirm_text: prefs?.confirm_text || "",
      ebd_text: prefs?.ebd_text || "",
    },
    onSubmit: async ({ value }) => {
      const prefs = {
        id: value.id,
        owner_id: value.owner_id,
        duree_min_rdv: parseInt(value.duree_min_rdv),
        duree_default_rdv: parseInt(value.duree_default_rdv),
        time_division: parseInt(value.time_division),
        email_expediteur: value.email_expediteur,
        email_subject: value.email_subject,
        email_text: value.email_text,
        ebd_subject: value.ebd_subject,
        sms_name: value.sms_name,
        sms_text: value.sms_text,
        ebd_text: value.ebd_text,
      };
      console.log("prefsToSubmit", JSON.stringify(prefs, null, 2));
      editPreferencesSaveMutation.mutate(prefs);
    },
  });

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);
  const alertUser = (e: BeforeUnloadEvent) => {
    if (prefsForm.state.isDirty) {
      e.preventDefault();
      e.returnValue = "o/";
      return "foo"; //for webkit
    }
  };

  const emailText = useStore(
    prefsForm.store,
    (state) => state.values.email_text
  );

  const ebdText = useStore(
    prefsForm.store,
    (state) => state.values.ebd_text
  );
  const emailSubject = useStore(
    prefsForm.store,
    (state) => state.values.email_subject
  );
  const ebdSubject = useStore(
    prefsForm.store,
    (state) => state.values.ebd_subject
  );

  const emailTextDisplay = convertTextForDisplay(
    emailText,
    new Date(2020, 0, 1),
    {
      heure: 10,
      minute: 0,
    },
    previewDoctorName,
    ebdText,
    "adresse-email-dentiste@exemple.fr",
  );

  const smsText = useStore(prefsForm.store, (state) => state.values.sms_text);
  const smsTextDisplay = convertTextForDisplay(smsText, new Date(2020, 0, 1), {
    heure: 10,
    minute: 0,
  });
  const smsCharsRemaining = smsText ? remainingChars(smsText) : 160;

  const senderName = useStore(
    prefsForm.store,
    (state) => state.values.sms_name
  );
  const senderNameCharsRemaining = remainingSenderChars(senderName);
  const confirm_text = useStore(
    prefsForm.store,
    (state) => state.values.confirm_text
  );
  const confirmTxtCharsRemaining = remainingChars(confirm_text);
  const confirmTextDisplay = convertTextForDisplay(
    confirm_text,
    new Date(2020, 0, 1),
    {
      heure: 10,
      minute: 0,
    },
  );

  const ebdTextDisplay = convertTextForDisplay(
    ebdText,
    new Date(2020, 0, 1),
    {
      heure: 10,
      minute: 0,
    },
    previewDoctorName,
    undefined,
    "adresse-email-dentiste@exemple.fr",
  );
  const emailSubjectDisplay = emailSubject.replace(
    /\{fullname\}/g,
    previewDoctorName
  );
  const ebdSubjectDisplay = ebdSubject.replace(
    /\{fullname\}/g,
    previewDoctorName
  );
  const isInvalidSms = smsCharsRemaining < 0;
  const isInvalidSenderName = senderNameCharsRemaining < 0;
  const onToggleEmailTxtEditing = () => {
    setIsEditingEmailTxt((prev) => !prev);
  };
  const onToggleSmsTxtEditing = () => {
    setIsEditingSmsTxt((prev) => !prev);
  };

  const trpcUtils = trpc.useContext();

  const onOpenEmailExpediteurEditing = () => {
    setIsEditingEmailExpediteur(true);
  };
  const onOpenSmsExpediteurEditing = () => {
    setIsEditingSmsName(true);
  };
  const onOpenConfirmTxtEditing = () => {
    setIsEditingConfirmText(true);
  };

  return (
    <div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          prefsForm.handleSubmit();
        }}
        className=" p-4"
      >
        <div className="bg-white p-4 rounded-md">
          <div className="font-bold my-2">Texte des rappels par E-Mail</div>

          <div className="">
            <div className="">
              <prefsForm.Field
                name="email_text"
                children={(field) => (
                  <>
                    <div className="ml-2 mb-1">
                      Ecrire {"{"}d{"}"} à l'endroit où vous voulez mettre la
                      date du RDV, {"{"}h{"}"} pour l'heure, et {"{"}fullname{"}"}
                      pour le nom du dentiste.
                    </div>
                    <div className="flex gap-2">
                      <textarea
                        className="rounded-md p-3 border-stone-200 border-solid border-2 bg-white resize-none w-1/3"
                        rows={8}
                        id="emailTextInput"
                        onChange={(e) => field.handleChange(e.target.value)}
                        value={field.state.value}
                      />
                      <textarea
                        className="rounded-md p-3 border-stone-200 border-solid border-2 bg-slate-100 italic resize-none w-1/3 cursor-not-allowed"
                        rows={8}
                        id="emailTextDisplay"
                        disabled
                        value={emailTextDisplay}
                      />
                    </div>
                  </>
                )}
              />
            </div>
            <prefsForm.Field
              name="email_expediteur"
              validators={{
                onChange: ({ value }) =>
                  z.string().email().safeParse(value).success
                    ? undefined
                    : "Email invalide",
              }}
              children={(field) => (
                <HInputGroup
                  label="Adresse Email Expéditeur "
                  id="emailExpediteurInput"
                  value={field.state.value}
                  onChange={field.handleChange}
                  isValid={field.state.meta.errors.length === 0}
                  isTouched={field.state.meta.isTouched}
                />
              )}
            />
          </div>
        </div>

        <div className="bg-white p-4 rounded-md mt-4">
          <div className="font-bold my-2">Objets des emails de rappel</div>
          <div className="ml-2 mb-3">
            Utilisez {"{fullname}"} pour insérer le nom du dentiste.
          </div>
          <div className="space-y-4">
            <prefsForm.Field
              name="email_subject"
              children={(field) => (
                <div>
                  <div className="mb-1 font-medium">Objet normal</div>
                  <div className="flex gap-2">
                    <input
                      className="rounded-md p-3 border-stone-200 border-solid border-2 bg-white w-1/3"
                      id="emailSubjectInput"
                      onChange={(e) => field.handleChange(e.target.value)}
                      value={field.state.value}
                    />
                    <input
                      className="rounded-md p-3 border-stone-200 border-solid border-2 bg-slate-100 italic w-1/3 cursor-not-allowed"
                      id="emailSubjectDisplay"
                      disabled
                      value={emailSubjectDisplay}
                    />
                  </div>
                </div>
              )}
            />
            <prefsForm.Field
              name="ebd_subject"
              children={(field) => (
                <div>
                  <div className="mb-1 font-medium">Objet EBD</div>
                  <div className="flex gap-2">
                    <input
                      className="rounded-md p-3 border-stone-200 border-solid border-2 bg-white w-1/3"
                      id="ebdSubjectInput"
                      onChange={(e) => field.handleChange(e.target.value)}
                      value={field.state.value}
                    />
                    <input
                      className="rounded-md p-3 border-stone-200 border-solid border-2 bg-slate-100 italic w-1/3 cursor-not-allowed"
                      id="ebdSubjectDisplay"
                      disabled
                      value={ebdSubjectDisplay}
                    />
                  </div>
                </div>
              )}
            />
          </div>
        </div>

        <div className="bg-white p-4 rounded-md mt-4">
          <div className="font-bold my-2">
            Texte d'avertissement EBD (moins de 25 ans)
          </div>
          <div className="ml-2 mb-1">
            Ce texte sera inséré dans les emails de rappel à la place de {"{ebd}"} si le patient a moins de 25 ans au jour du rendez-vous et n'a pas eu d'autre rdv honoré dans l'année civile. Utilisez {"{email_dentiste}"} pour insérer l'adresse email du dentiste.
          </div>
          <div className="ml-2 mb-1">
            Vous pouvez aussi utiliser {"{fullname}"} pour insérer le nom du dentiste.
          </div>
          <div className="flex gap-2">
            <prefsForm.Field
              name="ebd_text"
              children={(field) => (
                <>
                  <textarea
                    className="rounded-md p-3 border-stone-200 border-solid border-2 bg-white resize-none w-1/3"
                    rows={4}
                    id="ebdTextInput"
                    onChange={(e) => field.handleChange(e.target.value)}
                    value={field.state.value}
                  />
                  <textarea
                    className="rounded-md p-3 border-stone-200 border-solid border-2 bg-slate-100 italic resize-none w-1/3 cursor-not-allowed"
                    rows={4}
                    id="ebdTextDisplay"
                    disabled
                    value={ebdTextDisplay}
                  />
                </>
              )}
            />
          </div>
        </div>

        <div className="bg-white p-4 rounded-md mt-4">
          <div className="font-bold">Texte des rappels par SMS</div>
          <div className="">
            <div className="">
              <div className="">
                <prefsForm.Field
                  name="sms_text"
                  validators={{
                    onChange: ({ value }) =>
                      remainingChars(value) >= 0
                        ? undefined
                        : "Nombre de caractères dépassé",
                  }}
                  children={(field) => (
                    <>
                      <div className="ml-2 mb-1">
                        Ecrire {"{" + "d" + "}"} à l'endroit où vous voulez
                        mettre la date du RDV, {"{"}h{"}"} pour l'heure.
                        Certains caractères (ê, ë...) ne sont pas transmissibles
                        par sms.
                      </div>
                      <div className="flex gap-2">
                        <textarea
                          className={classNames(
                            "rounded-md p-3 border-stone-200 border-solid border-2 bg-white resize-none w-1/3",
                            !field.state.meta.isPristine &&
                              field.state.meta.errors.length > 0
                              ? "border-red-500 text-red-500 outline-red-500"
                              : ""
                          )}
                          rows={5}
                          id="smsTextInput"
                          onChange={(e) => field.handleChange(e.target.value)}
                          value={field.state.value}
                        />
                        <textarea
                          className="rounded-md p-3 border-stone-200 border-solid border-2 bg-slate-100 italic resize-none w-1/3 cursor-not-allowed"
                          rows={5}
                          id="smsTextDisplay"
                          disabled
                          value={smsTextDisplay}
                        />
                      </div>
                      <div>
                        <span
                        // className={classNames({
                        //   [styles.error]: field.state.meta.errors.length > 0,
                        // })}
                        >
                          {smsCharsRemaining} caractères restants
                        </span>
                      </div>
                    </>
                  )}
                />
              </div>
              <prefsForm.Field
                name="sms_name"
                validators={{
                  onChange: ({ value }) =>
                    remainingSenderChars(value) >= 0 && value.length > 0
                      ? undefined
                      : "Nombre de caractères dépassé",
                }}
                children={(field) => (
                  <div className="form-inline">
                    <div className="flex items-center gap-2">
                      <HInputGroup
                        label="Nom Expéditeur"
                        id="smsExpediteurInput"
                        value={field.state.value}
                        onChange={field.handleChange}
                        isTouched={field.state.meta.isTouched}
                        isValid={field.state.meta.errors.length === 0}
                      />
                      <span
                      // className={classNames({
                      //   [styles.error]: isInvalidSenderName,
                      // })}
                      >
                        {senderNameCharsRemaining} caractères restants
                      </span>
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        </div>

        <div className="bg-white p-4 rounded-md mt-4">
          <div className="font-bold">
            Texte des demandes de confirmation par SMS
          </div>
          <div className="">
            <div className="ml-2 mb-1">
              Ecrire {"{" + "d" + "}"} à l'endroit où vous voulez mettre la date
              du RDV, {"{"}h{"}"} pour l'heure. Certains caractères (ê, ë...) ne
              sont pas transmissibles par sms.
              <div className="">
                <prefsForm.Field
                  name="confirm_text"
                  validators={{
                    onChange: ({ value }) =>
                      remainingChars(value) >= 0 && value.length > 0
                        ? undefined
                        : "Nombre de caractères dépassé",
                  }}
                  children={(field) => (
                    <>
                      <div className="flex gap-2">
                        <textarea
                          className={classNames(
                            "rounded-md p-3 border-stone-200 border-solid border-2 bg-white resize-none w-1/3",
                            !field.state.meta.isPristine &&
                              field.state.meta.errors.length > 0
                              ? "border-red-500 text-red-500 outline-red-500"
                              : ""
                          )}
                          rows={5}
                          id="confirmTextInput"
                          onChange={(e) => field.handleChange(e.target.value)}
                          value={field.state.value}
                        />
                        <textarea
                          className="rounded-md p-3 border-stone-200 border-solid border-2 bg-slate-100 italic resize-none w-1/3 cursor-not-allowed"
                          rows={5}
                          id="confirmTextDisplay"
                          disabled
                          value={confirmTextDisplay || ""}
                        />
                      </div>
                      <div>{confirmTxtCharsRemaining} caractères restants</div>
                    </>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </form>
      <prefsForm.Subscribe
        selector={(state) => ({
          isSubmitting: state.isSubmitting,
          isValid: state.isValid,
          isDirty: state.isDirty,
        })}
        children={({ isSubmitting, isValid, isDirty }) => (
          <>
            {isDirty ? (
              <div
                className={classNames(
                  "flex justify-start pt-2 pb-6 px-3 gap-2",
                  isDirty && isValid ? "bg-green-300" : "bg-red-300"
                )}
              >
                <Button
                  onClick={prefsForm.handleSubmit}
                  disabled={isSubmitting || !isValid}
                  title="Enregistrer"
                  style="main"
                />
                <Button
                  onClick={() => prefsForm.reset()}
                  title="Annuler"
                  disabled={!isDirty}
                />
              </div>
            ) : null}
          </>
        )}
      />
    </div>
  );
};

export default RemindersParams;
